$(document).ready(function () {
  const $slider = $('.article-slider');

  $slider.slick({
    autoplay: true,
    infinite: true,
    dots: true,
    arrows: true,
    respondTo: 'window',
    centerMode: true,
    centerPadding: '20%',
  });

  function updateSliderSettings() {
    const windowWidth = $(window).width();
    if (windowWidth >= 750) {
      $slider.slick('slickSetOption', 'slidesToShow', 2, true);
    } else {
      $slider.slick('slickSetOption', 'slidesToShow', 1, true);
    }
  }

  updateSliderSettings();

  $(window).on('resize', updateSliderSettings);
});
